/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "CancelCreditLinePaymentRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "repaymentToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CancelCreditLinePaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CancelCreditLinePaymentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.CancelCreditLinePaymentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CancelCreditLinePaymentRequest @ squareup/corporate_card/service/cancel_credit_line_payment.proto at 9:1
 */
export const CancelCreditLinePaymentRequest = $root.lookupType('squareup.corporate_card.service.CancelCreditLinePaymentRequest');
fixType(CancelCreditLinePaymentRequest, {
  idempotenceToken: {
    notEmpty: true
  },
  creditLineId: {
    notEmpty: true
  },
  repaymentToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelCreditLinePaymentRequest);
/**
 * SOURCE CancelCreditLinePaymentResponse @ squareup/corporate_card/service/cancel_credit_line_payment.proto at 37:1
 */
export const CancelCreditLinePaymentResponse = $root.lookupType('squareup.corporate_card.service.CancelCreditLinePaymentResponse');
fixType(CancelCreditLinePaymentResponse);
Builder.createAndAttachToType(CancelCreditLinePaymentResponse);